<template>
  <v-dialog
      v-model="dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <v-text-field
                  outlined
                  v-model="province.name"
                  :label="$t('common:province')"
                  :rules="[
                    ruleRequired($t('utils:rules.required')),
                  ]"
              />

              <v-select
                  outlined
                  :items="countries"
                  item-text="translatedName"
                  item-value="id"
                  v-model="province.country"
                  :label="$t('common:country')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card
                  elevation="0"
                  flat
                  tile
                  class="pl-3 pt-3 pb-md-3"
              >
                <TwoButtonDialog
                    ref="saveButton"
                    :btn-text="$t('buttons:save')"
                    color="primary"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title', {name : $t('common:province') })"
                    :dialog-text="$t('dialog:save-btn-dialog', {name : $t('common:province') })"
                    :button1-text="$t('buttons:save')"
                    :button2-text="$t('buttons:cancel')"
                    @clickedButton1="updateForm()"
                    @clickedButton2="$refs.saveButton.showDialog = false"
                />
                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:back')"
                    color="grey"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title')"
                    :dialog-text="$t('dialog:save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="dialog=false"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import {ruleRequired} from '@/modules/core/services/rules';
import ProvinceService from '@/modules/settings/services/province-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "ProvinceForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  props: {
    countries: Array
  },
  data() {
    return {
      province: {},
      dialog: false,
      edit: false
    }
  },
  methods: {
    ruleRequired,
    updateForm() {
      if (!this.$refs.form.validate()) {
        this.$refs.saveButton.showDialog = false;
        window.scrollTo(0, 0);
        return;
      }

      this.dialog = false;
      ProvinceService.saveProvince(
          this.province,
          () => {
            if (!this.edit) {
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:province')}));
            } else {
              Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('common:province')}));
            }

            this.$emit('updateTable');
          },
          () => {
            if (!this.edit) {
              Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:province')}));
            } else {
              Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('common:province')}));
            }
          }
      )
    },
    initialization(item) {
      this.province = {};
      this.edit = false;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.province = item;
        this.edit = true;
      }

      this.dialog = true;
    }
  }
}
</script>
